import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import CheeroRedirectView from 'src/views/CheeroRedirect';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true,
    isAPIUnavailable: true
  }
}));
export default CheeroRedirectView;